import Vue from 'vue'
import App from './App.vue'
import store from './store/'

import router from './router'
Vue.router = router

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios);

if (process.env.NODE_ENV === 'production') {
	Vue.axios.defaults.baseURL = 'https://api.markkartering.se/api/v1';
} else {
	Vue.axios.defaults.baseURL = "http://api.markkartering.test/api/v1";
}

Vue.use(VueAxios, axios)

/**
 *	Create our message bus
 */
window.bus = new Vue()

import "./assets/style.css";

Vue.config.productionTip = false

Vue.axios.interceptors.response.use((response) => { // intercept the global error
	return response
}, function (error) {
	if (error.response.status === 401 && Vue.router.currentRoute.name != 'login') {
		Vue.router.push({name: 'login'});
	}

	// System Error
	else if (error.response.status === 500) {
		Vue.router.push({name: 'error-500'});
	}

	return Promise.reject(error)
})


/**
 *	Add the hasPermission prototype so we can check the permissions
 */
Vue.prototype.$hasPermission = function (user, slug) {
	return user.permissions[slug]
};

new Vue({
	created() {
		if (this.$store.getters['auth/isAuthenticated']) {
			Vue.axios.defaults.headers.common['Authorization'] = this.$store.getters['auth/access_token']
			this.$store.dispatch('auth/FETCH_USER');
		} else if(this.$store.getters['auth/access_token']) {
			this.$store.dispatch('auth/AUTH_LOGOUT');
		}
	},
  router,
  store,
  render: h => h(App)
}).$mount('#app')

/** Google Analytics */
const isLocalhost = Boolean(
	window.location.hostname === 'utskrift.niftitech.com' ||
	window.location.hostname === 'localhost' ||
	window.location.hostname === '[::1]' ||
	window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
)

if(process.env.NODE_ENV === 'production' && !isLocalhost) {
	router.onReady(() => {
		
		window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date
		
		ga('create', 'UA-66344126-10', 'auto')

		router.afterEach((to, from) => {
			ga('set', 'page', to.fullPath)
			ga('send', 'pageview')
		})
	})
}

import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

if(process.env.NODE_ENV === 'production') {
	Raven.config('https://9316a8328ce9492ab259024b69e91982@sentry.io/1393876')
    .addPlugin(RavenVue, Vue)
    .install();
}